import _ from 'lodash';

export function genClaimId() {
    return _.uniqueId('claim-');
}

export function genFeatureId() {
    return _.uniqueId('feature-');
}
